@if (vm.content) {
<div class="row">
   <div class="col-xs-12">
      <div class="accordion application-form">
         <div class="opener">
            <span class="num last"
               >X<i class="fa fa-check" aria-hidden="true"></i
            ></span>
            <h1>{{ vm.content.title }} - {{ stepAbortTitle }}</h1>
            <div [innerHtml]="stepAbortMessage"></div>
         </div>
         <div class="slide">
            <form action="#">
               <fieldset>
                  <legend class="sr-only">{{ stepAbortSubTitle }}</legend>
                  <div class="section">
                     <div class="row section__heading">
                        <div class="col-sm-12">
                           <h2>{{ stepAbortSubTitle }}</h2>
                        </div>
                     </div>
                     <app-identification-error-summary></app-identification-error-summary>
                  </div>
               </fieldset>
            </form>
         </div>
      </div>
   </div>
</div>
}
